// extracted by mini-css-extract-plugin
export default {"root":"ReactPdfViewer__root--32Xxr","text":"ReactPdfViewer__text--15Xvo"};